import { corpusForTargetMonthlySWP } from "../../engine/calculations";

const config = {
  key: "req-lumpsum-for-swp",
  title: "Lumpsum Required For Target Monthly SWP",
  category: "Target-Based",
  description: "Find the corpus you need today to draw a fixed monthly income for a set number of years.",
  fields: [
    { key: "monthlyWithdrawal", label: "Target monthly withdrawal", type: "currency", default: 50_000, min: 500, max: 50_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 7, min: 1, max: 20, assumptionKey: "debtReturn" },
    { key: "years", label: "Years the income should last", type: "number", default: 20, min: 1, max: 50 },
  ],
  compute(values) {
    const monthlyWithdrawal = Number(values.monthlyWithdrawal) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;

    const corpusNeeded = corpusForTargetMonthlySWP(monthlyWithdrawal, annualRate, years);

    return {
      headline: { label: "Corpus needed today", value: corpusNeeded },
      breakdown: [
        { label: "Monthly withdrawal", value: monthlyWithdrawal },
        { label: "Total withdrawn over the period", value: monthlyWithdrawal * years * 12 },
      ],
    };
  },
};

export default config;
